import { render, staticRenderFns } from "./ExternalServiceLink.vue?vue&type=template&id=798853ce&"
import script from "./ExternalServiceLink.vue?vue&type=script&lang=js&"
export * from "./ExternalServiceLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports